
import { Component, Mixins, Prop } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";

const barcodeSystemModule = getModule(BarcodeSystemModule);

@Component({
  components: {
    Select
  }
})
export default class StockOrderStatusSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  @Prop({ default: false })
  appendToBody: boolean;
  @Prop({ default: false })
  openFilter: boolean;

  get options() {
    if(this.openFilter != null)
    {
      return barcodeSystemModule.stockOrderStatuses.filter(x => x.isOpen == this.openFilter).map(x => ({ label: x.description, value: x.code }));
    }
    else
    {
      return barcodeSystemModule.stockOrderStatuses.map(x => ({ label: x.description, value: x.code }));
    }  
  }
}
